import { render, staticRenderFns } from "./PartnerCard.vue?vue&type=template&id=ef1bf798&scoped=true&"
import script from "./PartnerCard.vue?vue&type=script&lang=ts&"
export * from "./PartnerCard.vue?vue&type=script&lang=ts&"
import style0 from "./PartnerCard.vue?vue&type=style&index=0&id=ef1bf798&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef1bf798",
  null
  
)

export default component.exports